module.exports = __webpack_public_path__ + "static/rod_of_lordly_might-ec0501ce7fa0a0d9411601bcfb43c3de.jpeg";